import { Button, Box, Divider, Typography, Link, Badge } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FilterSortButton = styled(Button)(() => ({
  color: "black",
  borderColor: "#E8E8E8",
}));

export const FilterSortBadge = styled(Badge)(() => ({
  position: "absolute",
  top: 6,
  left: 3,
  "& .MuiBadge-badge": { width: "10px", height: "10px" },
}));

export const DrawerListWrapper = styled(Box)(() => ({
  maxWidth: 435,
  position: "relative",
  paddingBottom: "100px",
  height: "100%",
}));

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  margin: "30px 20px 20px",
  [theme.breakpoints.up("mobile")]: {
    margin: "50px 40px 20px",
  },
}));

export const FilterWrapper = styled(Box)(({ theme }) => ({
  margin: "0 20px",
  [theme.breakpoints.up("mobile")]: {
    margin: "0 40px",
  },
}));

export const CloseButton = styled(Link)(() => ({
  position: "absolute",
  right: 40,
  top: 52,
}));

export const StyleButton = styled(Button)(({ theme }) => ({
  borderRadius: 4,
  color: theme.palette.neutral.dark,
  fontSize: 12,
  borderColor: theme.palette.primary.gainsboro,
  "@media (hover: none)": {
    "&:hover": {
      borderColor: theme.palette.primary.gainsboro,
      borderWidth: 2,
    },
  },
  "&.selected": {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.up("mobile")]: {
    fontSize: 14,
  },
}));

export const ClearAllLink = styled(Link)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  color: theme.palette.primary.main,
  margin: "20px 0 0",
  textTransform: "none",
}));

export const FilterSortTitle = styled(Typography)(() => ({
  fontSize: 22,
  fontWeight: 700,
}));

export const FilterSortSubtitle = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 700,
  margin: "10px 0 16px",
}));

export const StyledDivider = styled(Divider)(() => ({
  margin: "30px 0 20px",
}));

export const ApplyContainer = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.primary.gainsboro}`,
  padding: "20px 40px",
  bottom: 0,
  textAlign: "center",
  boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
  backgroundColor: "white",
  position: "fixed",
  maxWidth: 435,
  width: "100%",
}));
